import request from 'request';

const BASE_URI = '/api/simple';



export async function post(params) {

    let url = params.controllerName + params.methodName;
    return request(url,{
        method: 'post',
        data: params,
    })
}

export async function list(params) {
    let url = params.controllerName + params.methodName;
    return request(url,{
        method: 'post',
        data: params,
    })
}

export async function download(params) {

    return request(BASE_URI + '/download', {
        data: params,
        method: 'post',
        responseType: 'blob'
    });
}

export async function postWait(params) {

    let url = params.controllerName + params.methodName;
    return await request(url,{
        method: 'post',
        data: params,
    })
}

export async function listWait(params) {
    let url = params.controllerName + params.methodName;
    return await request(url,{
        method: 'post',
        data: params,
    })
}

// 用于请求scantron服务的接口
export async function scantronPost(params) {
    let url1 = params.controllerName + params.methodName;
    console.log(url1);
    return request({
      url: '/scantronjava/scantron/api'  + url1,
      method: 'post',
      data: param,
      baseURL: '' 
    })
    
  }


export async function scantronGet(params) {
    let url = '/scantronjava/scantron/api/list/list'
    // 临时：直接使用axios，绕过request的拦截器
    return axios({
      url: url,
      method: 'get',
      params: params,
      baseURL: ''
    })
}

export async function scantronDown(param, id) {
    // id 拼接在路径中
    let url = `${param.controllerName}${param.methodName}?id=${id}`
    return axios({
      url: url,
      method: 'get',
      baseURL: '',
      responseType: 'arraybuffer', // 关键：添加这行，指定接收二进制数据
    })
}